/**
 * TXM-671 — grupos de colunas da tabela de Rúbricas (INSS, FGTS, IRRF).
 *
 * As `chave`s são as mesmas do contrato de exportação (api-relatorios e worker Go): o
 * Exportar manda exatamente as chaves das colunas visíveis. A ordem aqui é a ordem global
 * da tabela e da planilha — INSS, FGTS, IRRF. O backend processa os 3 grupos sempre; a
 * tela só decide o que exibe (INSS sempre; FGTS e IRRF sob demanda).
 */

export const COLUNAS_FIXAS_RUBRICAS = [
  "codigoRubrica",
  "descricaoRubrica",
  "periodoVigencia",
  "tipoRubrica",
];

export const GRUPOS_RUBRICAS = [
  {
    id: "inss",
    rotulo: "INSS",
    colunas: [
      { chave: "inssCodigo", rotulo: "Cód Incidência" },
      { chave: "inssDescricao", rotulo: "Descrição da Incidência" },
      { chave: "inssCategoria", rotulo: "Categoria Incidência INSS" },
    ],
  },
  {
    id: "fgts",
    rotulo: "FGTS",
    colunas: [
      { chave: "fgtsCodigo", rotulo: "Cód Incidência" },
      { chave: "fgtsDescricao", rotulo: "Descrição da Incidência" },
    ],
  },
  {
    id: "irrf",
    rotulo: "IRRF",
    colunas: [
      { chave: "irrfCodigo", rotulo: "Cód Incidência" },
      { chave: "irrfDescricao", rotulo: "Descrição da Incidência" },
    ],
  },
];

/** Ao abrir a aba só INSS aparece; a escolha não é persistida. */
export const GRUPOS_PADRAO_VISIVEIS = ["inss"];

/**
 * Chaves das colunas visíveis, na ordem global. INSS é sempre incluído; ids de grupo
 * desconhecidos são ignorados.
 * @param {string[]|undefined} gruposAtivos
 * @returns {string[]}
 */
export function colunasVisiveisRubricas(gruposAtivos) {
  const ativos = new Set(Array.isArray(gruposAtivos) ? gruposAtivos : []);
  ativos.add("inss");
  const chaves = [...COLUNAS_FIXAS_RUBRICAS];
  GRUPOS_RUBRICAS.forEach((grupo) => {
    if (ativos.has(grupo.id)) grupo.colunas.forEach((c) => chaves.push(c.chave));
  });
  return chaves;
}
